/* Similar Products loader.

   The theme's <product-recommendations> element gates its fetch behind an
   IntersectionObserver created in the element constructor. When the section
   is already inside the viewport at that moment - the normal case on mobile,
   where the product page is short enough that Similar Products starts on
   screen - the first notification is computed before layout, arrives with
   isIntersecting false, and the element then never crosses a threshold
   because it never moves. The row stays empty for the life of the page.

   This runs after load, finds any recommendations section that still has no
   cards, fetches the section and swaps it in. It is a no-op when the theme's
   own path already worked. */
(function () {
  'use strict';

  var LOADED = 'data-redesign-recommendations-loaded';

  function swap(host, markup) {
    var holder = document.createElement('div');
    holder.innerHTML = markup;

    /* The endpoint returns the whole section; the payload is the inner HTML
       of its own <product-recommendations>. */
    var source = holder.querySelector('product-recommendations');
    var payload = source ? source.innerHTML : '';
    if (!payload.trim()) return false;

    host.innerHTML = payload;
    return true;
  }

  function load(host) {
    if (host.hasAttribute(LOADED)) return;
    if (host.querySelector('.card-wrapper')) return;

    var url = host.dataset.url;
    if (!url) return;

    host.setAttribute(LOADED, 'true');

    fetch(url)
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (markup) {
        if (!swap(host, markup)) return;

        /* Card sliders inside the new markup need wiring; the shared
           initialiser is idempotent and skips already-bound sliders. */
        if (typeof window.initProductCardSliders === 'function') {
          window.initProductCardSliders();
        }
      })
      .catch(function () {
        /* Leave the section empty rather than showing a broken row, and let
           the element try again on a later call. */
        host.removeAttribute(LOADED);
      });
  }

  function run() {
    document.querySelectorAll('product-recommendations').forEach(load);
  }

  /* Give the theme's own observer a chance first, then fill any gap. */
  function schedule() {
    window.setTimeout(run, 600);
  }

  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });

  /* Theme editor re-renders sections in place. */
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(run, 300);
  });
})();
